import {  
    getFirestore, 
    query, 
    getDoc,
    doc,
    collection,
    getDocs,
    where
} from "firebase/firestore";
const getOrgList = async function(id, name) {

    let db = getFirestore();
    if( name != undefined ){
        let ref = collection(db, "wellness_org");
        const itemQuery = query( 
            ref,
            where('name', '==', name)
        );
        const docSnapa = await getDoc(itemQuery);
        return {...docSnapa.data(), ... { id: docSnapa.id }};
    }
    else if( id != undefined ){
        let ref = doc(db, "wellness_org", id );
        const docSnapa = await getDoc(ref);
        return {...docSnapa.data(), ... { id: docSnapa.id }};
    }
    else{
        let ref = collection(db, "wellness_org");
        const itemQuery = query( 
            ref
        );
        
        const docSnap = (await getDocs(itemQuery));
        const ItemList = [];
        if( docSnap.size ){
            docSnap.forEach( async (doc) => {
                ItemList.push({
                    ...doc.data(),
                    ...{ id: doc.id }
                });
            });
        }
        return ItemList;
    }
};
export default getOrgList;